import { render } from "./Step_4.vue?vue&type=template&id=16fab2ec"
import script from "./Step_4.vue?vue&type=script&lang=js"
export * from "./Step_4.vue?vue&type=script&lang=js"

import "./Step_4.vue?vue&type=style&index=0&id=16fab2ec&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__